module.exports = __webpack_public_path__ + "static/img/logo38.e1a66da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo38.png
// module id = 8cyQ
// module chunks = 1